/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export enum HeaderDynamicReport {
  duration = 'duration',
  sunRiseDifference = 'sunRiseDifference',
  sunSetDifference = 'sunSetDifference'
}
